import * as React from "react";
import { forwardRef } from "react";
const SvgAcceptNewOrdersInactive = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 22, viewBox: "0 0 20 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 15.16L8.04 11.2M11.96 11.24L8 15.2M14 3.02C17.33 3.2 19 4.43 19 9V15C19 19 18 21 13 21H7C2 21 1 19 1 15V9C1 4.44 2.67 3.2 6 3.02M8 5H12C14 5 14 4 14 3C14 1 13 1 12 1H8C7 1 6 1 6 3C6 5 7 5 8 5Z", stroke: "#DC2626", strokeWidth: 1.2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgAcceptNewOrdersInactive);
export default ForwardRef;
